export default {
  'deliveryPoint.additional.add': '+ Add Additional Delivery Point'
};
